import React, { useContext, useEffect, useState } from 'react'
import css from './Modal.module.css'
import { UserContext } from '../UseContext'
import {RxOpenInNewWindow} from 'react-icons/rx'
import {ImGithub} from 'react-icons/im'
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

const Modal = ({title,bannerone,bannertwo,bannerthree,bannerfour,live
,frontendlink,backendlink,workedon,about}) => {

const{modal,setModal}=useContext(UserContext)

// console.log("jjj")
// useEffect=(()=>{
//     setModal(true)
// },[])
    // const[works,setWorks]=useState[workedon]

console.log(workedon)
  return (
<>
{modal? 
    <>
   <div className={css.overallmadalbg}>
   <div className={css.modalbg} onClick={()=>{setModal(false)}}></div>
    <div className={css.modaldiv}>
    <div className={css.container}>
    <div  className={css.banner_contents}>
          <Swiper
            className={css.sliding_content}
            modules={[Navigation, Pagination, Autoplay]}
            slidesPerview={1}
            navigation={true}
            autoplay={{ delay: 1500 }}
            pagination={{ clickable: true }}
          >
            <SwiperSlide>
              <img className={css.slide_img} src={bannerone}  />
            </SwiperSlide>
            <SwiperSlide>
              <img className={css.slide_img} src={bannertwo} />
            </SwiperSlide>
            <SwiperSlide>
              <img className={css.slide_img}  src={bannerthree} />
            </SwiperSlide>
            <SwiperSlide>
              <img className={css.slide_img} src={bannerfour} />
            </SwiperSlide>
          </Swiper>
        </div>
        <div className={css.linkdiv}>

<a href={live} target="_blank"><RxOpenInNewWindow/> Live</a>


<div >
<a href={frontendlink} target="_blank"><ImGithub/> Frontend</a>
<a href={backendlink} target="_blank">Backend <ImGithub/></a>
</div>

        </div>
        <div className={css.workeddiv}>
            {workedon.map((get)=>{
                return(
                    <>
                    {/* <img src={get}/> */}
                    <p>{get}</p>
                    </>
                )
            })}
        </div>
        <p><span>{title} :</span>{about}</p>
    </div>
    </div>
   </div>
    </>:""
}
</>
  )
}

export default Modal